import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=04af4b41&scoped=true"
import script from "./LocationList.vue?vue&type=script&lang=js"
export * from "./LocationList.vue?vue&type=script&lang=js"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=04af4b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04af4b41",
  null
  
)

export default component.exports